<script setup>
import { useRoute } from "vue-router";
import ChannelsTable from "@/components/Channels/ChannelsTable.vue";

const route = useRoute();
console.log("RUTA Edit Channel PAPA");
</script>
<template>
  <div class="">
    <div>
      <ChannelsTable></ChannelsTable>
    </div>
  </div>
</template>
